import React, { useEffect, useRef, useState } from 'react'
import translations from './translations'
import HideMyProfile from './HideMyProfile'
import RefreshMyProfile from './RefreshMyProfile'
import MakeProfileSearchable from './MakeProfileSearchable'
import { TProfileSetting, useStore } from '../../../store'
import { API_REFRESH_PROFILE } from './constants'
import { Container } from './style.css'
import { ELanguage, Hooks, useHog, Utils } from '@microfrontends/react-components'
import ProfileStatus from './ProfileStatus'
import { useProfileSettingStore } from '../../../store/ProfileSetting'
import { ERefreshProfile } from './type'

const BASE_PATH = process.env.NEXT_PUBLIC_MS_BASE_PATH
const REFRESH_PROFILE_API = `${BASE_PATH}${API_REFRESH_PROFILE}`

export default function ProfileSettings() {
    const [loadingSearchable, setLoadingSearchable] = useState(true)
    const { langCode, profileSettingInfo, user, isShowPopupSetting } = useStore().state
    const { isOpenToWork, statusRefresh } = useProfileSettingStore().state
    const { tracking } = useHog()
    const isSentViewProfileSettingRef = useRef<Boolean>(false)

    const trans = Utils.createTranslator({ translations, currentLanguage: langCode, defaultLanguage: ELanguage.EN })

    const { resumeSetting, resumeSettingOption } = profileSettingInfo

    const initDataMakeSearchable = {
        data: {
            resumes: [...[resumeSetting.profileInfo], ...resumeSetting.attachInfo],
            profileSetting: resumeSettingOption as Partial<TProfileSetting>,
            searchableStatus: profileSettingInfo.searchableStatus as 0 | 1,
            unContactable: profileSettingInfo.unContactable as 0 | 1
        },
        accessToken: user?.accessToken ?? '',
        langCode,
        baseMsUrl: process.env.NEXT_PUBLIC_MS_BASE_PATH ?? ''
    }
    const [resumeStatusDetail] = Hooks.useMakeSearchable(initDataMakeSearchable)

    useEffect(() => {
        if (!isShowPopupSetting || (statusRefresh > 0 && !resumeStatusDetail.isSearchable) || isSentViewProfileSettingRef.current) {
            return
        }

        let statusRefreshText = 'Unset'
        if (statusRefresh === ERefreshProfile.Daily) {
            statusRefreshText = 'Daily'
        } else if (statusRefresh === ERefreshProfile.Weekly) {
            statusRefreshText = 'Weekly'
        }

        tracking({
            eventName: 'js_profile_management:view_profile_settings',
            properties: {
                isOpenToWork: isOpenToWork,
                statusRefresh: statusRefreshText,
                statusRefreshId: statusRefresh,
                isSearchable: resumeStatusDetail.isSearchable
            }
        })
        isSentViewProfileSettingRef.current = true
    }, [resumeStatusDetail, isShowPopupSetting])

    return (
        <Container>
            <MakeProfileSearchable
                urlRefresh={REFRESH_PROFILE_API}
                loadingSearchable={loadingSearchable}
                setLoadingSearchable={(e: boolean) => setLoadingSearchable(e)}
                trans={trans}
            />

            <Container gap={24}>
                <ProfileStatus trans={trans} />
                <RefreshMyProfile trans={trans} />
                <HideMyProfile trans={trans} />
            </Container>
        </Container>
    )
}
